import { Handle, Position } from '@xyflow/react'

export function RuleResultNode({ data }) {
  const connected = data.connected ?? false

  return (
    <div style={{
      background: '#1a1a10',
      border: `2px solid ${connected ? '#c0a020' : '#606010'}`,
      borderRadius: 8,
      padding: '12px 18px',
      minWidth: 200,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
      boxShadow: connected ? '0 0 10px rgba(200,160,0,0.25)' : 'none',
    }}>
      {/* Lightning bolt icon like Unreal */}
      <div style={{
        position: 'absolute', top: -14, right: 10,
        background: '#2a2a10',
        border: '1px solid #c0a020',
        borderRadius: '50%',
        width: 22, height: 22,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 12, color: '#c0a020',
      }}>
        ⚡
      </div>

      <div style={{ color: '#c0a020', fontWeight: 'bold', fontSize: 10, letterSpacing: 1, marginBottom: 8 }}>
        RESULT
      </div>

      {/* Can Enter Transition input */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, position: 'relative' }}>
        <Handle
          type="target"
          position={Position.Left}
          id="in"
          style={{ background: '#c04040', width: 12, height: 12 }}
        />
        <span style={{ marginLeft: 18, color: connected ? '#e08080' : '#605030', fontSize: 11 }}>
          {connected ? '● ' : '○ '}Can Enter Transition
        </span>
      </div>
    </div>
  )
}
